import { createSelector } from '@ngrx/store';

import { Company, UserAutoOptionAdapter } from '@shared/models';

import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { getUsersEntities } from '../users';
import { companiesAdapter, CompaniesState } from './companies.reducer';

export const getCompaniesState = createSelector(getCollectionsState, (state: CollectionsState) => !!state && state.companies);

const adaptCompany = (company: Company) =>
  !!company && {
    ...company,
    locationInput: {
      name: company.city,
      stateCode: company.stateCode,
      countryCode: company.countryCode,
      countryName: company.countryName,
    },
    accountManager:
      !!company.accountManagerId && !!company.accountManager && !!company.accountManager.id
        ? UserAutoOptionAdapter.toOption(company.accountManager)
        : {},
  };

export const {
  selectIds: getCompaniesIds,
  selectEntities: getCompaniesEntities,
  selectAll: getCompaniesAll,
  selectTotal: getCompaniesTotal,
} = companiesAdapter.getSelectors(getCompaniesState);

export const getCompaniesSelectedId = createSelector(getCompaniesState, (state: CompaniesState) => !!state && state.selectedId);
export const getCompaniesSelected = createSelector(
  getCompaniesEntities,
  getCompaniesSelectedId,
  (entities, selectedId) => !!selectedId && !!entities && entities[selectedId],
);

export const getCompanyIsLoaded = createSelector(getCompaniesEntities, (entities, { id }) => !!entities && !!id && !!entities[id]);

export const getCompanyById = createSelector(getCompaniesEntities, (entities, { id }) => !!entities && !!id && entities[id]);

export const getCompanyWithAccountManager = createSelector(
  getCompaniesSelected,
  getUsersEntities,
  (company, users): Company => !!company && !!users && { ...company, accountManager: users[company.accountManagerId] },
);

export const getCompanyAdapted = createSelector(getCompaniesEntities, getUsersEntities, (companies, users, { id }) =>
  !!id && !!companies[id]
    ? adaptCompany({
        ...companies[id],
        accountManager: !!users && users[companies[id].accountManagerId],
      })
    : {},
);
